/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';
import P from '../Text/P';

/**
 * A formatted text like markdown.
 * Currently we only support splitting into paragraphs, but we will continuedly add more formatting.
 * @param {object} props
 * @param {string} props.text
 * @param {import('../Text/pVariants').PVariants} [props.variant]
 */
export default function FormattedText({ text, variant, ...rest }) {
  if (!text) return null;
  return (
    <Box {...rest}>
      {text?.split('\n\n').map((p) => (
        <P key={p} variant={variant}>
          {p}
        </P>
      ))}
    </Box>
  );
}
